const getChatPageCount = (data: any): number => {
    return data?.response?.meta?.pagination?.pageCount
}

export default getChatPageCount
